module.exports = __webpack_public_path__ + "img/single_video.904017de.png";